<template>
    <el-dialog
            title="Create dispatcher"
            :visible.sync="showForm"
            append-to-body
            top="5vh"
            @closed="reset()"
    >
        <dispatcher-dialog-form 
            :form-data="formData"
            @updated="$emit('updated')"
        ></dispatcher-dialog-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button @click="save" type="primary">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
import DispatcherDialogForm from "./dispatcher-dialog-form";

export default {
        components: {
            DispatcherDialogForm
        },
        props: [
            'show',
        ],
        data() {
            return {
                formData: {},
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            },
        },
        methods: {
            save() {
                return axios.post(url(`admin/settings/dispatchers/create`), this.formData)
                    .then((response) => {
                        this.$message({
                            message: `Dispatcher created`,
                            type: 'success'
                        });

                        this.showForm = false;
                        this.$emit('updated');
                    });
            },
            reset() {
                this.formData = {
                    id: null,
                    name: "",
                    logo_id: null,
                    logo_url: null,
                    email: "",
                    phone: "",
                    info_short: [{ text: "" }],
                    info_long: [{ text: "" }],
                    is_primary: false,
                    is_click_to_call: false,
                    is_inactive: false,
                };
            },
        },
        created() {
            this.reset();
        }
    }
</script>
